import classNames from 'classnames';
import { memo } from 'react';
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs';

type Props = {
  count: number;
  onClick: any;
  activeSlide: number;
};

const SliderBullets = ({ count, onClick, activeSlide }: Props) => {
  const slidesArr = new Array(count).fill(true);
  const nextSlideHandler = () => {
    onClick(activeSlide + 1 === count ? 0 : activeSlide + 1, activeSlide + 2 === count)();
  };
  const prevSlideHandler = () => {
    onClick(activeSlide === 0 ? count - 1 : activeSlide - 1, activeSlide === 0)();
  };
  const handleClick = (idx: number) => {
    onClick(idx)();
  };

  return (
    <div className='tw:flex tw:w-full tw:justify-center tw:p-4'>
      <div className='tw:flex tw:w-full tw:items-center tw:justify-center tw:gap-8'>
        <div className='tw:hidden tw:cursor-pointer tw:lg:block' onClick={prevSlideHandler}>
          <BsArrowLeft size={22} />
        </div>

        <ul className='tw:mb-0 tw:flex tw:list-none tw:gap-2 tw:pl-0'>
          {slidesArr.map((_, idx) => (
            <li
              key={idx}
              onClick={() => handleClick(idx)}
              className={classNames(
                'tw:content-[" "] tw:inline-block tw:h-2 tw:w-2 tw:cursor-pointer tw:rounded-[100%] tw:border tw:border-brand-black',
                {
                  'tw:bg-transparent': activeSlide !== idx,
                  'tw:bg-brand-black': activeSlide === idx,
                }
              )}></li>
          ))}
        </ul>

        <div className='tw:hidden tw:cursor-pointer tw:lg:block' onClick={nextSlideHandler}>
          <BsArrowRight size={22} />
        </div>
      </div>
    </div>
  );
};

export default memo(SliderBullets);
